import type { ISEOProps } from "../types/core";

export const EmailActivationPageSEO: ISEOProps = {
  title: "Email Activation | Sugar Cribs",
  description:
    "Activate your Sugar Cribs account by verifying your email address. Check your inbox for the activation link.",
};
